import {
  Accordion,
  AccordionBody,
  AccordionHeading,
  AccordionItem,
  AccordionTitle,
  Col,
  Link,
  Row,
  Tab,
  TabList,
  Typography,
} from "@visa/vds";
import MCSGrid from "components/MCSGrid";
import MCSGridRevert from "../../components/MCSGridRevert";
import React, { useState } from "react";
import "./Overview.css";
import AuthPic from "../../_imgs/overview/Auth-Strategies-HighRes.png";
import FlowPic from "../../_imgs/overview/Flow.png";
import BenefitOne from "../../_imgs/overview/Benefit-Icon1-300ppi.png";
import BenefitTwo from "../../_imgs/overview/Benefit-Icon2-300ppi.png";
import BenefitThree from "../../_imgs/overview/Benefit-Icon3-300ppi.png";
import BenefitFour from "../../_imgs/overview/Benefit-Icon4-300ppi.png";
import { LIBRARY, GETTING_STARTED } from "../../_constants/PageRoutes";
import { useHistory } from "react-router-dom";

function Overview() {
  const history = useHistory();
  const clickHandler = () => history.push(GETTING_STARTED);
  const click3Handler = () => history.push(LIBRARY);
  const [selectedTab, setSelectedTab] = useState(0);
  const defaultExpandedPanels = [selectedTab];

  return (
    <MCSGridRevert>
      <Row>
        <Col className="vss-header vss-header-large-gap">
          <Typography
            tag="h1"
            variant="headline"
            className="overview-header"
          >
            Visa Secure Overview
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col xs={4} md={4} lg={4} xl={4} className="col-vss-image">
          <div className="vss-ilustration-image-panel">
            <img
              src="images/public/_blue_yellow-22_1920x1920.png"
              alt="Visa Secure with EMV 3DS"
            />
          </div>
        </Col>
        <Col
          xs={8}
          md={8}
          lg={8}
          xl={8}
          className="visa-secure-text-description"
        >
          <Typography variant="body" className="vss-text-body-large">
            Visa Secure is a global solution designed to make e-commerce
            transactions more secure by helping to ensure the transaction is
            initiated by the rightful owner of the account. Visa Secure is
            Visa’s program to support EMV 3DS. Within Visa Secure, Visa has
            products through Cardinal Commerce that support the ecosystem, such
            as Centinel 3DSS for the acceptance side and VCAS ACS for the
            issuing side. Implementing Visa Secure can help improve
            profitability through increased sales and reduced operational costs.
          </Typography>
          <br />
          <Typography variant="body" className="vss-text-body-large">
            The Three-Domain Secure (3-D Secure or 3DS) Protocol that Visa
            Secure is based on serves as the mechanism for cardholder
            authentication at the time of an e-commerce purchase. For merchants
            and issuers, Visa Secure helps provide an additional layer of
            security prior to authorization, and for cardholders, it helps
            create the trust they seek when shopping online.
          </Typography>
        </Col>
      </Row>
      <Row className="visa-secure-auth-description ">
        <Typography variant="body" className="vss-text-body-large">
          Visa Secure focuses on cardholder authentication for e-commerce
          transactions. Authentication and authorization are distinctly
          different processes with different business objectives:
        </Typography>
        <Row>
          <Col xs={12} md={12} lg={6} xl={6}>
            <Typography variant="body" className="vss-text-body-large">
              <span style={{ fontWeight: "bold" }}>Authentication</span> is the
              process of helping to ensure that the cardholder is the rightful
              owner of the card
            </Typography>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6}>
            <Typography variant="body" className="vss-text-body-large">
              <span style={{ fontWeight: "bold" }}>Authorization</span> is the
              process used by a card issuer to approve or decline a Visa payment
              transaction
            </Typography>
          </Col>
        </Row>
        <Typography variant="body" className="vss-text-body-large">
          Authentication using Visa Secure, if invoked by the merchant, occurs
          before authorization and is outside of the authorization stream. Once
          authentication is completed, then authorization may occur through the
          merchant’s acquirer following the standard process.
        </Typography>
      </Row>
      <Row>
        <Col xs={12} md={12} lg={12} xl={12} className="col-vss-image">
          <img className="auth-pic" src={AuthPic} alt="Auth Strategies" />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12} lg={12} xl={12} className="col-vss-content">
          <Typography
            tag="h1"
            variant="headline"
            className="overview-header"
            style={{ color: "#1434cb" }}
          >
            How does Visa Secure work?
          </Typography>
          <Typography variant="body" className="vss-text-body-large">
            When a cardholder makes a purchase at a participating merchant
            website, Visa Secure authenticates the transaction in these easy
            steps:
          </Typography>
        </Col>
      </Row>
      <Row className="visa-secure-process">
        <Col xs={4} md={12} lg={4} xl={4}>
          <ol className="ordered-list">
            <li>
              <Row className="process-title">Cardholder Checkout</Row>
              <Row>The customer enters his or her account details</Row>
            </li>
            <li>
              <Row className="process-title">Authentication Request</Row>
              <Row>
                The merchant sends request with transaction & device data
              </Row>
            </li>
            <li>
              <Row className="process-title">Authentication Decision</Row>
              <Row>
                The issuer authenticates the cardholder using its preferred
                authentication method and determines if additional
                authentication is required.
              </Row>
            </li>
            <li>
              <Row className="process-title">Authentication Result</Row>
              <Row>
                The issuer replies to the merchant with the authentication
                outcome.
              </Row>
            </li>
            <li>
              <Row className="process-title">Authorization Request</Row>
              <Row>
                If authenticated, the merchant submits the transaction for
                authorization and includes the electronic commerce indicator
                (ECI) indicating the cardholder authentication outcome.
              </Row>
            </li>
          </ol>
        </Col>
        <Col xs={8} md={12} lg={7} xl={7}>
          <img
            className="visa-secure-process-pic"
            src={FlowPic}
            alt="Auth Strategies"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={8} md={8} lg={8} xl={8} className="col-vss-content">
          <Typography
            tag="h1"
            variant="headline"
            className="overview-header"
            style={{ color: "#1434cb" }}
          >
            Benefits
          </Typography>
        </Col>
      </Row>
      <div className="tabs">
        <Row>
          <TabList selectedTab={selectedTab}>
            <Tab
              className="tab-header"
              onClick={(e, k) => setSelectedTab(k)}
              aria-controls="potential-merchant-benefits"
            >
              Potential Merchant Benefits
            </Tab>
            <Tab
              className="tab-header"
              onClick={(e, k) => setSelectedTab(k)}
              aria-controls="potential-issuer-benefits"
            >
              Potential Issuer Benefits
            </Tab>
          </TabList>
        </Row>
        <div
          className="tab-panel"
          hidden={selectedTab === 0 ? undefined : true}
          role="tabpanel"
        >
          <ul className="merchant-benefits">
            <li>
              Optimal customer experience – Supports different payment channels
              delivering a unified web and mobile experience.
            </li>
            <li>
              Improves authorization rates and reduces fraud – EMV 3DS provides
              an enhanced data exchange between merchants and issuers to help
              improve authorization decisioning and fraud detection.
            </li>
            <li>
              More control and Functionality – allows for better integration of
              the authentication process into the merchant’s shopping
              experience.
            </li>
            <li>
              Fraud Liability Protection – Provides protection against
              fraudulent disputes for fully authenticated (ECI05) or
              merchant-attempted authentication (ECI06) transactions.
            </li>
          </ul>
        </div>
        <div
          className="tab-panel"
          hidden={selectedTab === 1 ? undefined : true}
          role="tabpanel"
        >
          <ul className="issuer-benefits">
            <li>
              Optimal cardholder experience – delivers a simple and secure
              authentication experience for the cardholder.
            </li>
            <li>
              Increased Issuer Control – supports a wide range of authentication
              challenge methods for cardholder security, while also streamlining
              risk-based decisioning to remove friction for low-risk
              transactions
            </li>
            <li>
              Flexible device support – supports secure payments for
              card-not-present purchases across different payment channels.
            </li>
            <li>
              Reduced abandonment rates – Using more data to help issuers make
              better risk decisions, results in a reduction in abandonment rate
              and more completed sales.
            </li>
          </ul>
        </div>
      </div>
      <Row id="accordians">
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <Accordion
            // id="accordion-test-id"
            defaultExpandedId={defaultExpandedPanels}
          >
            <AccordionItem>
              <AccordionHeading>
                <AccordionTitle className="accordion-title">
                  Potential Merchant Benefits
                </AccordionTitle>
              </AccordionHeading>
              <AccordionBody>
                <ul className="merchant-benefits">
                  <li>
                    Optimal customer experience – Supports different payment
                    channels delivering a unified web and mobile experience.
                  </li>
                  <li>
                    Improves authorization rates and reduces fraud – EMV 3DS
                    provides an enhanced data exchange between merchants and
                    issuers to help improve authorization decisioning and fraud
                    detection.
                  </li>
                  <li>
                    More control and Functionality – allows for better
                    integration of the authentication process into the
                    merchant’s shopping experience.
                  </li>
                  <li>
                    Fraud Liability Protection – Provides protection against
                    fraudulent disputes for fully authenticated (ECI05) or
                    merchant-attempted authentication (ECI06) transactions.
                  </li>
                </ul>
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeading>
                <AccordionTitle className="accordion-title">
                  Potential Issuer Benefits
                </AccordionTitle>
              </AccordionHeading>
              <AccordionBody>
                <ul className="issuer-benefits">
                  <li>
                    Optimal cardholder experience – delivers a simple and secure
                    authentication experience for the cardholder.
                  </li>
                  <li>
                    Increased Issuer Control – supports a wide range of
                    authentication challenge methods for cardholder security,
                    while also streamlining risk-based decisioning to remove
                    friction for low-risk transactions
                  </li>
                  <li>
                    Flexible device support – supports secure payments for
                    card-hot-present purchases across different payment
                    channels.
                  </li>
                  <li>
                    Reduced abandonment rates – Using more data to help issuers
                    make better risk decisions, results in a reduction in
                    abandonment rate and more completed sales.
                  </li>
                </ul>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </Col>
      </Row>
      <Row className="visa-secure-benefits">
        <Col sm={6} md={6} lg={3} xl={3}>
          <Row className="benefit-image">
            <img
              src={BenefitOne}
              alt="Benefit 1"
              style={{ height: "10rem" }}
            />
          </Row>
          <br />
          <Row className="benefit-title">
            Delivers an Optimal Customer Experience
          </Row>
          <Row className="benefit-description">
            <br />
            Supports different payment channels, delivering a unified web and
            mobile experiences and Provides less friction on low-risk
            transactions
          </Row>
        </Col>
        <Col sm={6} md={6} lg={3} xl={3}>
          <Row className="benefit-image">
            <img
              src={BenefitTwo}
              alt="Benefit 2"
              style={{ height: "10rem" }}
            />
          </Row>
          <br />
          <Row className="benefit-title">Improves Authorization Rates</Row>
          <Row className="benefit-description">
            <br />
            An enhanced data exchange between originator and issuers (135+ data
            points) that improves authorization decisioning
          </Row>
        </Col>
        <Col sm={6} md={6} lg={3} xl={3}>
          <Row className="benefit-image">
            <img
              src={BenefitThree}
              alt="Benefit 3"
              style={{ height: "10rem" }}
            />
          </Row>
          <br />
          <Row className="benefit-title">Reduces Fraud</Row>
          <Row className="benefit-description">
            <br />
            Additional security layer of fraud detection for online transactions
            that adds a speedy authentication step if the transaction is deemd
            to be high-risk.
          </Row>
        </Col>
        <Col sm={6} md={6} lg={3} xl={3}>
          <Row className="benefit-image">
            <img
              src={BenefitFour}
              alt="Benefit 4"
              style={{ height: "10rem" }}
            />
          </Row>
          <br />
          <Row className="benefit-title">More Control and Functionality</Row>
          <Row className="benefit-description">
            <br />
            Offers originator more control of the user experience and can expand
            reach through increased platform functionality
          </Row>
        </Col>
      </Row>
      <MCSGrid>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            <Typography className="vss-learn-more">
              {/* Interested in working with Visa Secure?  */}
              Review our{" "}
              <Link
                id="gettingStartedGuideLink"
                onClick={clickHandler}
                inline
                className="vss-link-big"
                aria-label="Getting Started Guide"
              >
                Getting Started Guide{" "}
              </Link>
              to learn more or visit the{" "}
              <Link
                id="vssLibraryLink"
                onClick={click3Handler}
                inline
                className="vss-link-big"
                aria-label="VSS Library"
              >
                VSS Library
              </Link>{" "}
              to access additional resources.
            </Typography>
          </Col>
        </Row>
      </MCSGrid>
    </MCSGridRevert>
  );
}

export default Overview;
